import React from 'react';
import FontAwesome from 'react-fontawesome';

import { StandardButton } from 'js/academia_components/buttons/standard_button.wjs';

export class WorkMentionsSelector extends React.Component<{
  isBlurred?: boolean;
}> {
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'prevProps' implicitly has an 'any' type... Remove this comment to see the full error message
  componentDidUpdate(prevProps) {
    if (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isMe' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      prevProps.isMe !== this.props.isMe ||
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'notMe' does not exist on type 'Readonly<... Remove this comment to see the full error message
      prevProps.notMe !== this.props.notMe
    ) {
      this.setState({ isLoading: false });
    }
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isLoading' does not exist on type 'Reado... Remove this comment to see the full error message
    if (this.state.isLoading) {
      return (
        <div className="wp-workCard_item wp-workCard--mentionsSelector">
          <i className="fa fa-spinner fa-spin fa-lg" />
        </div>
      );
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isMe' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    } else if (this.props.isMe) {
      return (
        <div className="wp-workCard_item wp-workCard--mentionsSelector">
          <FontAwesome name="check" />
          <span>
            Confirmed as <strong>This is Me</strong>
          </span>
          <span>
            <a
              href="javascript:void(0);"
              onClick={() => this.takeAction('undo_is_me')}
            >
              Undo
            </a>
          </span>
        </div>
      );
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'notMe' does not exist on type 'Readonly<... Remove this comment to see the full error message
    } else if (this.props.notMe) {
      return (
        <div className="wp-workCard_item wp-workCard--mentionsSelector">
          <FontAwesome name="close" />
          <span>
            Marked as <strong>Not Me</strong>
          </span>
          <span>
            <a
              href="javascript:void(0);"
              onClick={() => this.takeAction('undo_not_me')}
            >
              Undo
            </a>
          </span>
        </div>
      );
    } else {
      return (
        <div className="wp-workCard_item wp-workCard--mentionsSelector btnContainer">
          <StandardButton
            emphasize
            onClick={() => this.takeAction('is_me')}
            disabled={this.props.isBlurred} // Disable button if blurred
          >
            This is me
          </StandardButton>
          <StandardButton
            onClick={() => this.takeAction('not_me')}
            disabled={this.props.isBlurred} // Disable button if blurred
          >
            This is not me
          </StandardButton>
        </div>
      );
    }
  }

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'action' implicitly has an 'any' type.
  takeAction(action) {
    this.setState({ isLoading: true });
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onSelect' does not exist on type 'Readon... Remove this comment to see the full error message
    this.props.onSelect({ action });
  }
}
